import React from 'react';
import { Trans } from 'react-i18next';
import { useQueryClient } from 'react-query';
import { Modal, ModalContent } from 'src/shared/ui/components/Modal';

import { CreateParkingRequestForm } from '@shared/parking-requests/components/CreateParkingRequestForm';
import { createParkingRequest } from '@shared/parking-requests/endpoints/createParkingRequest';
import { Button } from '@shared/ui/components/Button';
import { Icon } from '@shared/ui/components/Icon';
import { ModalTrigger } from '@shared/ui/components/Modal/ModalTrigger';
import { confetti } from '@shared/utils/helpers';

type CreateParkingRequestButtonProps = {
  registrationId: number;
};

export function CreateParkingRequestButton({ registrationId }: CreateParkingRequestButtonProps) {
  const queryClient = useQueryClient();

  return (
    <Modal>
      <ModalTrigger asChild>
        <Button size="sm">
          <Icon icon="plus" />
          <Trans>RegistrationParkingAddButton</Trans>
        </Button>
      </ModalTrigger>
      <ModalContent title="Create Parking Request" size="2xl">
        {({ close }) => (
          <CreateParkingRequestForm
            registrationId={registrationId}
            action={(data) => createParkingRequest(registrationId, data)}
            onSave={() => {
              close();
              confetti(true);
              queryClient.invalidateQueries('registration-parkings');
            }}
            onCancel={close}
          />
        )}
      </ModalContent>
    </Modal>
  );
}
